module.exports = __webpack_public_path__ + "img/htEvent_introduce_banner_jp.5c8d3399.jpg";